/**
 * "2m ago", without pulling in a date library for one string.
 *
 * Anything older than a week gets an absolute date instead: "43d ago" is a
 * number the reader has to convert, where "12 Mar" is one they can just read.
 */
export function relativeTime(iso: string, now: number = Date.now()): string {
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return '';

  const seconds = Math.round((now - then) / 1000);
  // Clock skew between the server and the browser can put a fresh row slightly
  // in the future; "just now" is the honest answer there, not "-1m ago".
  if (seconds < 45) return 'just now';

  const minutes = Math.round(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;

  const hours = Math.round(minutes / 60);
  if (hours < 24) return `${hours}h ago`;

  const days = Math.round(hours / 24);
  if (days < 7) return `${days}d ago`;

  return new Date(then).toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
}
